import ApiError from '@/features/api/error'
import { logLevelToSentrySeverityLevel } from '@/logger/constants'
import { ApolloError } from '@apollo/client'
import { type LogLayerTransportParams, LoggerlessTransport } from '@loglayer/transport'
import * as Sentry from '@sentry/react-native'
import merge from 'lodash.merge'

export class SentryTransport extends LoggerlessTransport {
    shipToLogger = ({ logLevel, messages, data }: LogLayerTransportParams): any[] => {
        Sentry.withScope((scope) => {
            scope.setLevel(logLevelToSentrySeverityLevel[logLevel])

            const merged = merge({}, data?.context, data?.metadata)

            const { extras, tags } = merged

            if (typeof extras === 'object') {
                Object.entries(extras).forEach(([key, extra]) => {
                    scope.setExtra(key, extra)
                })
            }

            if (typeof tags === 'object') {
                Object.entries(tags).forEach(([key, tag]) => {
                    scope.setTag(key, typeof tag === 'string' ? tag : JSON.stringify(tag))
                })
            }

            let error = data?.error

            if (error) {
                if (error instanceof ApiError) scope.setExtra('apiError', error)
                if (error instanceof ApolloError) scope.setExtra('apolloError', error)

                Sentry.captureException(error)

                return
            }

            Sentry.captureMessage(messages.join('; '))
        })

        return messages
    }
}
